/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_TitleInputs */

const en_ai_title = /** @type {(inputs: Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI provider`)
};

const de_ai_title = /** @type {(inputs: Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Anbieter`)
};

/**
* | output |
* | --- |
* | "AI provider" |
*
* @param {Ai_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_title = /** @type {((inputs?: Ai_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_title(inputs)
	return en_ai_title(inputs)
});